import { useRouter } from 'next/router'
import { useMemo } from 'react'
import useMidTermFilters from './useMidTermFilters'
const useSearchParams = () => {
  const { allUnRemovableFilters } = useMidTermFilters()
  const router = useRouter()
  const routeOne = router.query?.routes?.[0]
  const routeTwo = router.query?.routes?.[1]

  const queries = useMemo(() => {
    const { routes, ...restQueries } = router.query
    return restQueries
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath.split('#')])

  const params = useMemo(
    () => ({
      city: routeOne === 'city' ? routeTwo : '',
      province: routeOne === 'province' ? routeTwo : '',
      village: routeOne === 'village' ? routeTwo : '',
      tag: routeOne === 'tag' ? routeTwo : '',
      phrase: router.query?.phrase || '',
      url: router.asPath,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [routeOne, routeTwo, router.query?.phrase],
  )
  const handleSetQueryParams = data => {
    if (typeof data === 'object') {
      const newData: any = { ...data }

      // after each filter redirects to page 1
      if (
        !Object.keys(newData).every(key => key === 'page') &&
        router.query.page
      ) {
        newData.page = undefined
      }

      if (data.indoor_pool && data.outdoor_pool) {
        newData.indoor_pool = undefined
        newData.outdoor_pool = undefined
        newData.pool = 1
      }

      const query = { ...router.query, ...newData, routes: undefined }

      if (query.mid_term) {
        Object.keys(query).forEach(key => {
          if (!allUnRemovableFilters.includes(key) && key !== 'mid_term') {
            delete query[key]
          }
        })
      }
      // remove all undefined parameters from above object
      const optimizedQuery = Object.keys(query).reduce((acc, curr) => {
        return {
          ...acc,
          ...(query[curr] && { [curr]: query[curr] }),
        }
      }, {})

      let pathname = '/search'
      if (routeOne && routeTwo) pathname = `${routeOne}/${routeTwo}`
      setTimeout(() => {
        router.replace({
          pathname: pathname.split('#')[0],
          query: optimizedQuery,
        })
      }, 0)
    }
  }

  return {
    setQuery: data => handleSetQueryParams(data),
    params,
    queries,
    routerAsPath: router.asPath.split('#')[0],
  }
}

export default useSearchParams
